<template>
  <div class="together">
    <div class="together__content">
      <h1>Together</h1>

      <div class="together_timer">
        <div class="together_timer__item">
          {{ timeElapsed.years }}<span class="together_timer__value">years</span>
        </div>

        <div class="together_timer__item">
          {{ timeElapsed.days }}<span class="together_timer__value">days</span>
        </div>

        <div class="together_timer__item">
          {{ timeElapsed.hours }}<span class="together_timer__value">hours</span>
        </div>

        <div class="together_timer__item">
          {{ timeElapsed.minutes }}<span class="together_timer__value">minutes</span>
        </div>

        <div class="together_timer__item">
          {{ timeElapsed.seconds }}<span class="together_timer__value">seconds</span>
        </div>
      </div>
    </div>

    <video class="together__video" autoplay muted loop>
      <source src="../assets/i/bg_video.mp4" type="video/mp4">
    </video>
  </div>

  <div v-if="isVisible" class="together__preview" @click="playAudio">ENTER</div>
</template>

<script setup>
import { ref, onMounted, onUnmounted } from "vue"
document.title = 'Together4ever'

const startDate = new Date("2022-10-10T00:00:00")
const timeElapsed = ref('')
let timer = null

const updateTime = () => {
  const now = new Date()
  let diff = Math.floor((now - startDate) / 1000)

  const years = Math.floor(diff / (365 * 24 * 3600))
  diff %= 365 * 24 * 3600

  const days = Math.floor(diff / (24 * 3600))
  diff %= 24 * 3600

  const hours = Math.floor(diff / 3600)
  diff %= 3600

  const minutes = Math.floor(diff / 60)
  const seconds = diff % 60

  timeElapsed.value = { years, days, hours, minutes, seconds }
}

const isVisible = ref(true)

onMounted(() => {
  updateTime()
  timer = setInterval(updateTime, 1000)
})

onUnmounted(() => {
  clearInterval(timer)
})

const audio = new Audio(require('../assets/i/after_dark.mp3'))
audio.type = 'audio/mp3'
audio.loop = true

const playAudio = () => {
  audio.play()
  isVisible.value = false
}
</script>

<style lang="scss">
.together {
  align-content: center;
  align-items: center;
  color: #fff;
  display: flex;
  flex-direction: column;
  height: 100%;
  height: 100vh;
  justify-content: center;
  left: 0;
  position: fixed;
  top: 0;
  width: 100%;
  z-index: 1;

  h1 {
    letter-spacing: 0.5em;
  }

  &__content {
    position: relative;
    z-index: 9;
  }

  &_timer {
    display: flex;
    font-size: 7rem;
    font-weight: 700;
    text-align: center;
    text-shadow: 0 0 6px #000;

    &__item {
      margin: 0 .1em 0 0;
      position: relative;
    }

    &__value {
      font-size: .25em;
      font-weight: 400;
      margin: 0 0 0 .1em;
      opacity: .55;
    }
  }

  &__preview {
    background-color: #fff;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 5rem;
    height: 100%;
    left: 0;
    position: fixed;
    top: 0;
    width: 100%;
    z-index: 3;
  }

  &__video {
    height: 100%;
    object-fit: cover;
    position: absolute;
    left: 0;
    display: block;
    top: 0;
    z-index: 6;
    width: 100%;
  }
}
</style>
